export default __webpack_public_path__ + "static/media/planninghover.2acb1efb.png";